// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"223":"commons","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","756":"component---src-pages-privacy-policy-tsx"}[chunkId] + "-" + {"223":"1c2e72eff351a504e9e3","245":"873e52085481626f78a5","453":"b3db278cc5e71b864aa3","756":"465d4590fe8cc614bd7f"}[chunkId] + ".js";
};